import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

// Styles
import './logo-block.scss';

type TLogoBlockProps = {};

export const LogoBlock: FC<TLogoBlockProps> = (
  {}: TLogoBlockProps
) => {

  const navigate = useNavigate();

  const onLogoClick = (): void => {
    navigate('/home');
  }

  return (
    <div className="logo-block" onClick={ onLogoClick }>
      <img src={ '/assets/images/logo.svg' } alt={ 'logo' }/>
    </div>
  );
}
